import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { login } from '../services/api';
import { showSuccessToast, showErrorToast, showLoadingToast, updateLoadingToastSuccess, updateLoadingToastError } from '../utils/toastConfig';
import './Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { loginUser } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    
    if (!username || !password) {
      showErrorToast('Please enter username and password');
      setLoading(false);
      return;
    }
    
    const toastId = showLoadingToast('Logging in...');
    
    try {
      const { data } = await login({ username, password });
      loginUser(data.user, data.token);
      updateLoadingToastSuccess(toastId, 'Login successful! 🎉');
      setTimeout(() => {
        window.location.href = '/dashboard';
      }, 1000);
    } catch (err) {
      const errorMsg = err.response?.data?.message || 'Login failed. Please try again.';
      setError(errorMsg);
      updateLoadingToastError(toastId, errorMsg);
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-left">
        <div className="login-left-content">
          <img src="/veramasa.png" alt="Veramasa Logo" className="brand-logo" />
          <h1>Welcome to Invoice Generator</h1>
          <p className="tagline">GST-Compliant Automated Invoicing System</p>
          <div className="features">
            <div className="feature-item">
              <div className="feature-icon">✓</div>
              <div className="feature-text">
                <h3>GST Compliance</h3>
                <p>Generate fully compliant GST invoices instantly</p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-icon">✓</div>
              <div className="feature-text">
                <h3>Automated System</h3>
                <p>Save time with our intelligent automation</p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-icon">✓</div>
              <div className="feature-text">
                <h3>Professional Templates</h3>
                <p>Beautiful, customizable invoice templates</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="login-right">
        <div className="login-form-wrapper">
          <div className="login-header">
            <h2>Sign In</h2>
            <p>Access your invoice dashboard</p>
          </div>
          
          <form onSubmit={handleSubmit}>
            {error && <div className="error-msg">{error}</div>}
            
            <div className="form-group">
              <label>Username or Email</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter username or email"
                required
              />
            </div>
            
            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                required
              />
            </div>
            
            <button type="submit" className="btn-login" disabled={loading}>
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;